import { httpClient } from '../http-client'
import { useThemeStore } from '@/lib/stores/theme-store'
import type {
  ClientAnswer,
  Answer,
  UpdateClientAnswerParams,
  DeleteClientAnswerParams,
  GetClientAnswersParams,
  ClientAnswerRetrieve,
} from '@/types/api'

/**
 * Saves made by this app: the server grants gamification XP for completions
 * (`x-gamification-source: web`) in the tenant of the current theme.
 */
function writeHeaders(): Record<string, string> {
  const mentorId = useThemeStore.getState().currentTheme?.mentor_id
  return {
    'x-gamification-source': 'web',
    ...(mentorId ? { 'mentor-id': mentorId } : {}),
  }
}

/**
 * ClientAnswersService - Gerencia respostas de alunos em ferramentas
 */
class ClientAnswersService {
  /**
   * GET - Buscar respostas de um usuário em uma área
   */
  async getClientAnswers(params: GetClientAnswersParams): Promise<ClientAnswerRetrieve[]> {
    const response = await httpClient.get('/client-answers', {
      params: {
        productId: params.productId,
        userId: params.userId,
      },
    })
    return response.data
  }

  /**
   * POST - Criar ou atualizar resposta (Upsert)
   */
  async upsertClientAnswer(params: Answer, userId: string): Promise<ClientAnswer> {
    const response = await httpClient.post(
      '/client-answers',
      {
        ...params,
        user_id: userId,
      },
      { headers: writeHeaders() },
    )
    return response.data
  }

  /**
   * PUT - Atualizar resposta por ID
   */
  async updateClientAnswer(params: UpdateClientAnswerParams, userId: string): Promise<ClientAnswer> {
    const response = await httpClient.put(
      '/client-answers',
      {
        ...params,
        user_id: userId,
      },
      { headers: writeHeaders() },
    )
    return response.data
  }

  /**
   * DELETE - Deletar resposta
   */
  async deleteClientAnswer(params: DeleteClientAnswerParams, userId: string): Promise<void> {
    await httpClient.delete('/client-answers/answer', {
      data: {
        ...params,
        user_id: userId,
      },
    })
  }
}

export const clientAnswersService = new ClientAnswersService()

